import { observer } from "mobx-react-lite";
import { useContext, useEffect } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { toast } from "react-toastify";

const GenericBrowsePageResizeHelper = () => {
  const rootStore = useContext(RootStoreContext);
  const { companyTheme } = rootStore.commonStore;
  const { isMobileMediaQuery, setIsMobileMediaQuery } =
    rootStore.responsiveStore;

  const handleResize = () => {
    // We execute the same script as before
    let vh = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    //toast.error(`EVENTO handleResize - vh : ${vh}`);
  };
  

  // **** IMPORTANTE: USARE QUESTO USEEFFECT SOLO PER I FIX GRAFICI ****
  useEffect(() => {

    //  !!!!!!! document.body.style.paddingRight = '0px';  !!!!!!!  serve per nn avere il padding right quando si apre il menu nel caso in cui ho accesso al globalguest.  prima avevo il paddingright 2px dovuto alla modale del pin del gloablguest
   // prima avevo il paddingright 2px dovuto alla modale del pin (è una modale dove mi indica di voler visualizzare il documento precedentemente caricato) del globalguest
   
      document.body.style.paddingRight = '0px'; 

    let vh = document.documentElement.clientHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    // We listen to the resize event
    window.addEventListener("resize", handleResize);

    if (companyTheme!.oldToolbar) {
      document.documentElement.style.setProperty("--toolbar", `210px`);
      document.documentElement.style.setProperty("--toolbarFull", `130px`);
    } else {
      if (isMobileMediaQuery) {
        document.documentElement.style.setProperty("--toolbar", `200px`);
        document.documentElement.style.setProperty("--toolbarFull", `120px`);
        document.documentElement.style.setProperty("--toolbarFullscreen",`121px` )
      } else {
        document.documentElement.style.setProperty("--toolbar", `240px`);
        document.documentElement.style.setProperty("--toolbarFull", `160px`);
        document.documentElement.style.setProperty("--toolbarFullscreen",`162px` )
      }
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [companyTheme, isMobileMediaQuery]);

  return <></>;
};

export default observer(GenericBrowsePageResizeHelper);
